export default __webpack_public_path__ + "static/media/proposition_list_empty.b649d988.png";